import { WebClient } from "./server/WebClient";

export interface SubmitFeedbackRequest {
    assetId: string;
    mode: AssistantMode;
    topics: string | undefined;
    scriptureReferences: string | undefined;
    assistantResponse: string;
    feedback: string | undefined;
    thumbsUp: boolean | undefined;
}

export interface SubmitFeedbackResponse {
    success: boolean;
    errorMessage?: string;
}

export enum AssistantMode { 
    GetStarted = 1,
    FeelingStuck = 2,
    Analyze = 3,
}

export const AssistantService = {
    submitFeedback: (request: SubmitFeedbackRequest) => WebClient.Post.Validated("api/Assistant/SubmitFeedback", request),
}
